import React from "react";
import { SectionSeparator } from "../../atom/SectionSeparator";
import { ExamCardProps, RecentCard } from "../dashboard/main/RecentCard";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../utils/date";
import { NoExams } from "../../molecules/exam/NoExams";
import { ParticipantExam } from "../../../types/components";
import { getResponsiblePersons } from "../../../utils/exam";

interface RecentExamsProps {
  data?: ParticipantExam[] | null;
}

export const RecentExams: React.FC<RecentExamsProps> = ({ data }) => {
  const { t } = useTranslation();

  const recentExamsArr = !data
    ? []
    : data?.map(({ exam, total_score, is_passed, certificate }): ExamCardProps => {
        const { exam_type, responsible_persons, code, date_to, questions_number } = exam;
        const { name } = exam_type;

        return {
          title: code,
          type: t(name),
          questions: questions_number,
          date: formatDate(date_to),
          authorizedPerson: getResponsiblePersons(responsible_persons),
          score: `${total_score ?? 0} / ${questions_number ?? 0}`,
          isPassed: !!is_passed,
          certificate,
        };
      });

  const noExams = !recentExamsArr?.[0];

  return (
    <div className="px-[52px] mt-[80px] pt-8 pb-10 flex flex-col gap-14">
      <SectionSeparator label={t("Recent")} type="secondary" />

      <div className={`grid gap-10 ${noExams ? "grid-cols-1" : "grid-cols-2"}`}>
        {noExams && <NoExams label="No recent exams." />}
        {recentExamsArr.map(
          ({ title, type, questions, date, score, isPassed, authorizedPerson, certificate }) => (
            <RecentCard
              key={title}
              title={title}
              type={type}
              questions={questions}
              authorizedPerson={authorizedPerson}
              score={score}
              isPassed={isPassed}
              date={date}
              certificate={certificate}
            />
          ),
        )}
      </div>
    </div>
  );
};
